import React, { useContext } from 'react';
import PropTypes from 'prop-types';

//context
import GalleryContext from '../../context/GalleryContext';

//components
import Loading from '../common/Loading';
import GalleryItem from './GalleryItem';

const GalleryItems = props => {
    
    const { idPhoto } = props;
    const { loading } = useContext(GalleryContext); 

    return (
            (loading)
                ? <Loading />
                : <GalleryItem idPhoto={idPhoto} />
    )
}

export default GalleryItems;

GalleryItems.propTypes = {
    idPhoto: PropTypes.string.isRequired,
}